import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import SonarcloudConfigListing from './SonarcloudConfigListing'
import SonarcloudCredentialsForm from './SonarcloudCredentialsForm'

export default function SonarcloudPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={SonarcloudCredentialsForm}
            PullConfigListingView={SonarcloudConfigListing}
            RunOnDemandButtonText={'Sync tool components'}
        />
    )
}